function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { previewProductListApi } from "@/api/marketing/preview-product";
import { isShowOptions } from "@/views/marketing/preview-product/enums";
export default {
  name: 'PreviewProductList',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    limit: {
      // 选择条数上限
      type: Number,
      default: 100
    },
    isDefault: {
      type: Boolean,
      default: true
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    checked: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      list: [],
      selectList: [],
      selectRows: [],
      // 当前页选中行数组
      allSelectList: [],
      // 所有数据的选中数组
      multipleSelection: []
    };
  },
  computed: {
    formData: function formData() {
      return [{
        label: '商户名称',
        prop: 'name',
        defaultValue: '',
        type: 'input'
      }, {
        label: '上架状态',
        prop: 'isShow',
        defaultValue: '',
        type: 'select',
        options: {
          list: isShowOptions
        }
      }];
    },
    columns: function columns() {
      return [{
        key: 'id',
        visible: true,
        label: "ID",
        width: 140
      }, {
        key: 'name',
        visible: true,
        label: "\u5546\u54C1\u540D\u79F0"
      }, {
        key: 'platId',
        visible: true,
        label: "\u5546\u57CE\u5546\u54C1ID",
        width: 100
      }, {
        key: 'image',
        visible: true,
        label: "\u5546\u54C1\u56FE",
        width: 100
      }, {
        key: 'price',
        visible: true,
        label: "\u5546\u54C1\u4EF7\u683C",
        width: 100
      }, {
        key: 'isShow',
        visible: true,
        label: "\u4E0A\u67B6\u72B6\u6001",
        width: 100,
        formatter: 'tag',
        formatOptions: {
          list: isShowOptions
        }
      }];
    },
    defaultValues: function defaultValues() {
      var _this = this;
      return this.isDefault ? this.checked.map(function (item) {
        return "".concat(item[_this.valueKey]);
      }) : [];
    },
    allSelectValues: function allSelectValues() {
      var _this2 = this;
      return this.allSelectList.map(function (item) {
        return "".concat(item[_this2.valueKey]);
      });
    },
    addableCount: function addableCount() {
      return this.limit - this.allSelectValues.length;
    }
  },
  created: function created() {
    this.allSelectList = JSON.parse(JSON.stringify(this.checked));
  },
  methods: {
    close: function close() {
      this.$emit('closeDialog', null);
    },
    getList: function getList(params) {
      var _this3 = this;
      return previewProductListApi(params).then(function (data) {
        var list = data.list,
          total = data.total;
        _this3.list = list.map(function (item) {
          return _objectSpread(_defineProperty({}, _this3.valueKey, "".concat(item.id)), item);
        });
        return {
          list: _this3.list,
          total: total,
          selectionFilter: _this3.selectionFilter
        };
      });
    },
    selectionFilter: function selectionFilter(item) {
      return this.allSelectValues.includes("".concat(item[this.valueKey]));
    },
    handleSelectAll: function handleSelectAll(selection) {
      if (this.addableCount > 0 && selection.length > 0) {
        // 还有可添加席位，且选择数量大于0的情况下，添加选中
        this.handleSelect(selection);
      } else {
        // 清除当页所有数据
        return this.handleSelect([]);
        // const list = selection.length > 0 ? selection : this.list;
        // // 当前页有选中状态，清空该勾选项
        // for (let i = list.length - 1; i >= 0; i--) {
        //   // 此处删除选中状态，会影响到selection数组的长度，所以使用倒序删除
        //   const row = list[i];
        //   const value = `${row[this.valueKey]}`;
        //   if (this.defaultValues.includes(value)) {
        //     // 在必填项里，添加选中状态
        //     this.$refs.searchPage.toggleRowSelection(row, true);
        //   } else {
        //     // 不在必填项里，删除选中状态
        //     this.$refs.searchPage.toggleRowSelection(row, false);
        //     const idx = this.allSelectValues.indexOf(value);
        //     if (idx > -1) {
        //       this.allSelectList.splice(idx, 1);
        //     }
        //     const rowIdx = this.selectRows.indexOf(row);
        //     if (rowIdx > -1) {
        //       this.selectRows.splice(rowIdx, 1);
        //     }
        //   }
        // }
      }
    },
    handleSelect: function handleSelect(selection) {
      var _this4 = this;
      var addableCount = this.addableCount;
      // 1. 查出已选中的项
      var selectRows = selection.filter(this.selectionFilter);
      // 2. 将未选中的项添加至列表中
      if (addableCount > 0 && selection.length > 0) {
        var addCount = 0;
        for (var i = 0; i < selection.length; i++) {
          var item = selection[i];
          if (!this.allSelectValues.includes(item[this.valueKey]) && addableCount > addCount) {
            selectRows.push(item);
            addCount++;
          }
        }
      }
      this.selectRows = selectRows;
      var selectionIds = selectRows.map(function (item) {
        return item[_this4.valueKey];
      });
      // 3. 对列表中的项进行 选中/取消选中
      this.list.forEach(function (row) {
        var value = "".concat(row[_this4.valueKey]);
        if (selectionIds.includes(value) || _this4.defaultValues.includes(value)) {
          // 列表中已存在该项 或 在必填项里，添加选中状态
          _this4.$refs.searchPage.toggleRowSelection(row, true);
          if (!_this4.allSelectValues.includes(value)) {
            _this4.allSelectList.push(row);
          }
        } else {
          // 列表中不存在该项 且 不在必填项里，删除选中状态
          _this4.$refs.searchPage.toggleRowSelection(row, false);
          var idx = _this4.allSelectValues.indexOf(value);
          if (idx > -1) {
            _this4.allSelectList.splice(idx, 1);
          }
        }
      });
    },
    // 标签删除
    removeItem: function removeItem(value) {
      for (var i = 0; i < this.allSelectValues.length; i++) {
        if (this.allSelectValues[i] === value) {
          this.allSelectList.splice(i, 1);
          break;
        }
      }
      for (var _i = 0; _i < this.selectRows.length; _i++) {
        if ("".concat(this.selectRows[_i][this.valueKey]) === value) {
          this.$refs.searchPage.toggleRowSelection(this.selectRows[_i], false);
          break;
        }
      }
    },
    handleSubmit: function handleSubmit() {
      this.$emit('getStoreItem', this.allSelectList);
    },
    singleSelect: function singleSelect(row) {
      this.$emit('getStoreItem', row);
    }
  }
};